// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".23c7f1cb511e5ce7ba3cca924e31417d29e9820b.chunk.js";
};